var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(this.loginInvalid || this.$root.user.authToken === null)?_c('div',[_c('login',{on:{"loggedIn":_vm.whenloggedIn}})],1):(this.$root.store.event)?_c('div',[_c('navbar-top'),_c('navbar-left'),_c('router-view')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }